// extracted by mini-css-extract-plugin
export default {"list":"switch_list__pR38p","itemWrapper":"switch_itemWrapper__rAmOX","itemWrapperStyled":"switch_itemWrapperStyled__+CM2Q","switchWrapper":"switch_switchWrapper__W+iKe"};